/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Plan} from '../../core/_models'
import Avatar from 'react-avatar'

type Props = {
  plan: Plan
}

const PlanInfoCell: FC<Props> = ({plan}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
      <a href='#'>
        {/* {plan.profile ? (
          <div className='symbol-label'>
            <img
              src={toAbsoluteUrl(`/media/${plan.profile}`)}
              alt={plan.name}
              className='w-100'
            />
          </div>
        ) : ( */}
        <Avatar size='40' round='20px' maxInitials={2} name={plan.name}></Avatar>
        {/* )} */}
      </a>
    </div>
    <div className='d-flex flex-column'>
      <a href='#' className='text-gray-800 text-hover-primary mb-1'>
        {plan.name}
      </a>
      {/* <span>{plan.email}</span> */}
    </div>
  </div>
)

export {PlanInfoCell,
  
}
